const canvasSketch = require('canvas-sketch');
const random = require('canvas-sketch-util/random');
const seedRandom = require('seed-random');

var seed, 
    seeded;

const settings = {
  dimensions        : [ 800, 800 ],
  pixelsPerInch     : 300,
  pixelRatio        : 2,
  exportPixelRatio  : 5,
  scaleToFit        : true,
  scaleToFitPadding : 0,
  units             : 'px',
}

window.$fxhashFeatures = {}

function setFeature(key, value) {
  if (window.$fxhashFeatures[key] != undefined)
    window.$fxhashFeatures[key] += value
  else
    window.$fxhashFeatures[key] = value
}

const sketch = () => {
  return ({ context, width, height }) => {
    seed = window.fxhash || Math.random()*1000
    console.log('seed', seed)
    seedRandom(seed, { global: true })
    seeded = random.createRandom(seed)

    context.fillStyle = 'white' 
    context.fillRect(0, 0, width, height)

    drawDottedSquare(context, width, height)
  }
}

function drawDottedSquare(context, width, height) {
  const x = 20
  const y = 20
  const w = 760
  const h = 760
  const pointCount = Math.round(seeded.range(50000,450000));
  let density = 'unknown'
  if (pointCount > 0 && pointCount <= 100000)
    density = 'very_low'
  if (pointCount > 100000 && pointCount <= 200000)
    density = 'low'
  if (pointCount > 200000 && pointCount <= 300000)
    density = 'medium'
  if (pointCount > 300000 && pointCount <= 400000)
    density = 'high'
  if (pointCount > 400000 && pointCount <= 450000)
    density = 'very_high'
  setFeature('noise', density)
  setFeature('points', pointCount)
  console.log(density, pointCount)
 
  let points = Array.from(new Array(pointCount)).map(() => {
    return [
      seeded.range(x, w+x),
      seeded.range(y, h+x)
    ];
  });

  points.forEach(p => {
    context.beginPath()
    context.fillStyle = `rgba(0,0,0,${seeded.range(0.001, 1)})`
    context.arc(p[0], p[1], 1, 0, 2*Math.PI)
    context.fill()
    context.closePath()
  })
  context.closePath()
}

canvasSketch(sketch, settings);
